// usage.js
export const INITIAL_STATE = {
  billingCycleOffset: 0,
};

// action types
const SET_BILLING_CYCLE = "appoptics/billing-usage/SET_BILLING_CYCLE";

// action creators
export const setBillingCycleOffset = billingCycleOffset => ({
  type: SET_BILLING_CYCLE,
  billingCycleOffset,
});

// reducer
const usageReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_BILLING_CYCLE: {
      const { billingCycleOffset = state.billingCycleOffset } = action;
      return {
        ...state,
        billingCycleOffset: billingCycleOffset || 0,
      };
    }
    default:
      return state;
  }
};
export default usageReportReducer;
